<template>
  <router-link role="button"
               :to="query"
               class="btn btn-primary mb-4">
    <icon class="btn-icon" name="plus-circle"></icon>
    Connect Integration
  </router-link>
</template>

<script>

  export default {
    props: {
      channelId: {
        type: String,
        default: ''
      }
    },

    computed: {
      query() {
        if (this.channelId) {
          return {
            name: 'administration.channel-detail.integrations.new',
            param: {id: this.channelId}
          }
        }

        return {
          name: 'administration.integrations.new'
        }
      }
    }
  }
</script>
